module.exports = __webpack_public_path__ + "img/3x.ef2b61f.jpg";